<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Contact Grid</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Contact Grid-->
                <div class="contact-grid-container">


                    <div class="row no-margin">

                        <!-- Contact Grid 1 -->
                        <div class="col-6 paddingleft0">
                            <div class="contactgrid">
                                <div class="media">
                                    <img class="mr-3" src="/static/images/elizabeth-lizarraga.jpg" alt="Elizabeth Lizarraga">
                                    <div class="media-body">
                                        <h5 class="mt-0">Elizabeth Lizarraga</h5>
                                        <h6>Director of Human Resources, VVG</h6>
                                        <p>795 Folsom Ave, Suite 600 San Francisco, CADGE 94107</p>
                                        <span>Contact: <strong>(123) 456-7890</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Contact Grid 1 -->


                        <!-- Contact Grid 2 -->
                        <div class="col-6 paddingright0">
                            <div class="contactgrid">
                                <div class="media">
                                    <img class="mr-3" src="/static/images/elizabeth-lizarraga.jpg" alt="Elizabeth Lizarraga">
                                    <div class="media-body">
                                        <h5 class="mt-0">Elizabeth Lizarraga</h5>
                                        <h6>Director of Human Resources, VVG</h6>
                                        <p>795 Folsom Ave, Suite 600 San Francisco, CADGE 94107</p>
                                        <span>Contact: <strong>(123) 456-7890</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Contact Grid 2 -->

                        <!--height space-->
                        <div class="height30"></div>
                        <!--height space-->

                        <!-- Contact Grid 3 -->
                        <div class="col-6 paddingleft0">
                            <div class="contactgrid">
                                <div class="media">
                                    <img class="mr-3" src="/static/images/elizabeth-lizarraga.jpg" alt="Elizabeth Lizarraga">
                                    <div class="media-body">
                                        <h5 class="mt-0">Elizabeth Lizarraga</h5>
                                        <h6>Director of Human Resources, VVG</h6>
                                        <p>795 Folsom Ave, Suite 600 San Francisco, CADGE 94107</p>
                                        <span>Contact: <strong>(123) 456-7890</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Contact Grid 3 -->



                        <!-- Contact Grid 4 -->
                        <div class="col-6 paddingright0">
                            <div class="contactgrid">
                                <div class="media">
                                    <img class="mr-3" src="/static/images/elizabeth-lizarraga.jpg" alt="Elizabeth Lizarraga">
                                    <div class="media-body">
                                        <h5 class="mt-0">Elizabeth Lizarraga</h5>
                                        <h6>Director of Human Resources, VVG</h6>
                                        <p>795 Folsom Ave, Suite 600 San Francisco, CADGE 94107</p>
                                        <span>Contact: <strong>(123) 456-7890</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Contact Grid 4 -->



                    </div>
                </div>
                <!--Contact Grid-->


            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/contact-grid.vue